import axios from './axiosInit';
import store from '@/store';

import URL from './url';

const login = async (data) =>
{
    try
    {
        store.dispatch('loader/show');
        const result = await axios.post(URL.HPSBRIDGE_SLUG + '/se/user/login', data)
        store.dispatch('loader/hide');
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const logout = async (data) =>
{
    try
    {
        store.dispatch('loader/show');
        const result = await axios.post(URL.HPSBRIDGE_SLUG + '/se/user/logout', data)
        store.dispatch('loader/hide');
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const generateOtp = async (data) =>
{
    try
    {
        store.dispatch('loader/show');
        const result = await axios.post(URL.HPSBRIDGE_SLUG + '/se/Otp/generateOtp', data)  // _beta
        store.dispatch('loader/hide');
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

const verifyOTP = async (data) =>
{
    try
    {
        store.dispatch('loader/show');
        const result = await axios.post(URL.HPSBRIDGE_SLUG + '/se/Otp/validateOtp', data)
        store.dispatch('loader/hide');
        return result
    } catch (e)
    {
        // console.log(e)
    }
}

export default {
    login,
    logout,
    generateOtp,
    verifyOTP
}
